import _classCallCheck from "C:\\Users\\montg\\Desktop\\Projects\\suild-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\montg\\Desktop\\Projects\\suild-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\montg\\Desktop\\Projects\\suild-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\montg\\Desktop\\Projects\\suild-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\montg\\Desktop\\Projects\\suild-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\montg\\Desktop\\Projects\\suild-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";

/*
    react-image-appear v1.2.23
    Copyright (c) 2018 Arun Michael Dsouza (amdsouza92@gmail.com)
    Licence: MIT
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LOADER, LOADER_STYLE, PLACEHOLDER, PLACEHOLDER_STYLE, ANIMATION, ANIMATION_DURATION, EASING } from './constants';
import { injectAnimationsScript } from './helpers';
injectAnimationsScript();

var ReactImageAppear = /*#__PURE__*/function (_Component) {
  _inherits(ReactImageAppear, _Component);

  function ReactImageAppear(props) {
    var _this;

    _classCallCheck(this, ReactImageAppear);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactImageAppear).call(this, props));
    _this.state = {
      imgComponent: null
    };
    _this.imageOnLoad = _this.imageOnLoad.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getImageDimensions = _this.getImageDimensions.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.parseComputedDimensions = _this.parseComputedDimensions.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.createPlaceholder = _this.createPlaceholder.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getPlaceholderStyle = _this.getPlaceholderStyle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.createLoader = _this.createLoader.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getLoaderStyle = _this.getLoaderStyle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ReactImageAppear, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          src = _this$props.src,
          className = _this$props.className;
      var imgElement;
      this.setState(function (prevState, props) {
        return {
          imgComponent: React.createElement('img', {
            src: src,
            onLoad: _this2.imageOnLoad,
            style: {
              opacity: 0
            },
            className: className,
            ref: function ref(_ref) {
              imgElement = _ref;
            }
          })
        };
      }, function () {
        _this2.getImageDimensions(imgElement);
      });
    }
  }, {
    key: "imageOnLoad",
    value: function imageOnLoad() {
      var _this$props2 = this.props,
          src = _this$props2.src,
          animation = _this$props2.animation,
          animationDuration = _this$props2.animationDuration,
          easing = _this$props2.easing,
          className = _this$props2.className;
      this.setState(function (prevState, props) {
        return {
          imgComponent: React.createElement('img', {
            src: src,
            style: {
              animation: "".concat(animation, " ").concat(animationDuration, " ").concat(easing)
            },
            className: className
          })
        };
      });
    }
  }, {
    key: "getImageDimensions",
    value: function getImageDimensions(imgElement) {
      var _this3 = this;

      var that = this,
          dimensionsInterval = setInterval(function () {
        var _this3$parseComputedD = _this3.parseComputedDimensions(imgElement),
            width = _this3$parseComputedD.width,
            height = _this3$parseComputedD.height;

        if (width && height) {
          clearInterval(dimensionsInterval);
          that.createPlaceholder(width, height);
        }
      }, 10);
    }
  }, {
    key: "parseComputedDimensions",
    value: function parseComputedDimensions(el) {
      return {
        width: Number(window.getComputedStyle(el).width.match(/\d+/)),
        height: Number(window.getComputedStyle(el).height.match(/\d+/))
      };
    }
  }, {
    key: "createPlaceholder",
    value: function createPlaceholder(width, height) {
      var imgComponent = this.state.imgComponent,
          placeholderClass = this.props.placeholderClass;
      var placeholder = React.createElement('div', {
        style: this.getPlaceholderStyle(width, height),
        className: placeholderClass
      }, React.cloneElement(imgComponent), this.createLoader());
      this.setState(function (prevState, props) {
        return {
          imgComponent: placeholder
        };
      });
    }
  }, {
    key: "getPlaceholderStyle",
    value: function getPlaceholderStyle(width, height) {
      var _this$props3 = this.props,
          placeholderStyle = _this$props3.placeholderStyle,
          placeholder = _this$props3.placeholder;
      var placeholderStyling = Object.assign({}, PLACEHOLDER_STYLE, placeholderStyle);

      switch (typeof placeholder) {
        case 'boolean':
          if (placeholder) {
            placeholderStyling = Object.assign({}, placeholderStyling, {
              backgroundImage: "url(".concat(PLACEHOLDER, ")")
            });
          }

          break;

        case 'string':
          placeholderStyling = Object.assign({}, placeholderStyling, {
            backgroundImage: "url(".concat(placeholder, ")")
          });
          break;
      }

      return Object.assign({}, placeholderStyling, {
        width: width,
        height: height
      });
    }
  }, {
    key: "createLoader",
    value: function createLoader() {
      var _this$props4 = this.props,
          loader = _this$props4.loader,
          loaderClass = _this$props4.loaderClass,
          showLoader = _this$props4.showLoader;
      return showLoader ? React.createElement('img', {
        src: loader ? loader : LOADER,
        style: this.getLoaderStyle(),
        className: loaderClass
      }) : null;
    }
  }, {
    key: "getLoaderStyle",
    value: function getLoaderStyle() {
      var loaderStyle = this.props.loaderStyle;
      return Object.assign({}, LOADER_STYLE, loaderStyle);
    }
  }, {
    key: "render",
    value: function render() {
      var imgComponent = this.state.imgComponent;
      return imgComponent;
    }
  }]);

  return ReactImageAppear;
}(Component);

ReactImageAppear.propTypes = {
  src: PropTypes.string.isRequired,
  loader: PropTypes.string,
  loaderStyle: PropTypes.object,
  loaderClass: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  placeholderStyle: PropTypes.object,
  placeholderClass: PropTypes.string,
  animation: PropTypes.string,
  animationDuration: PropTypes.string,
  easing: PropTypes.string,
  showLoader: PropTypes.bool,
  className: PropTypes.string
};
ReactImageAppear.defaultProps = {
  loader: LOADER,
  loaderStyle: {},
  loaderClass: '',
  placeholder: false,
  placeholderStyle: {},
  placeholderClass: '',
  animation: ANIMATION,
  animationDuration: ANIMATION_DURATION,
  easing: EASING,
  showLoader: true,
  className: ''
};
export default ReactImageAppear;